import React from 'react';
import PropTypes from 'prop-types';
// import { DataGridToolbar } from '../../../components/DataGridToolbar';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';

// DataGridToolbar is used, despite its small coupling to Orders
const TableToolbar = ({ openSidebar, ...props }) => <DataGridToolbar {...props} onOpenSidebar = {openSidebar}/>;

TableToolbar.defaultProps = {
  showAll: false,
  filterToolbar: true,
  columnsToolbar: true,
  densityToolbar: true,
  exportToolbar: false,
  containerStyle: {},
  searchStyle: {}
};

TableToolbar.propTypes = {
  openSidebar: PropTypes.func,
  hideSidebar: PropTypes.func,
  miniView: PropTypes.bool,
  searchCallback: PropTypes.func,
  showAll: PropTypes.bool,
  filterToolbar: PropTypes.bool,
  columnsToolbar: PropTypes.bool,
  densityToolbar: PropTypes.bool,
  exportToolbar: PropTypes.bool,
  containerStyle: PropTypes.object,
  searchStyle: PropTypes.object
};

export default TableToolbar;
